import{memo,Suspense as S}from'react'
import{Outlet}from'react-router-dom'
import{Navbar,SocialLinkFixed}from'components'
export default memo(():React.JSX.Element=><S><Navbar/><Outlet/><SocialLinkFixed/></S>)